<app-tool-list
  *ngIf="hasFilterOptions()"
  [tableData]="tableData"
  [defaultSortOrder]="defaultSortOrder"
  [tableFilters]="filters"
  [searchParams]="searchParams"
  [toolModelExportParams]="toolModelExportParams"
  dataType="inventories"
  source="inventories"></app-tool-list>

  <app-tool-inventory-modal></app-tool-inventory-modal>
  <app-tool-inventory-transfer></app-tool-inventory-transfer>
